import { render } from "./PartnerOneMain.vue?vue&type=template&id=2de0a4b0"
import script from "./PartnerOneMain.vue?vue&type=script&lang=js"
export * from "./PartnerOneMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__